import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';

export const TrackedActivity = ({ isSelected, options, onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Tracked Activity</span>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>>
                        id={'battlecards-tracked-activity-driver'}
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        options={options}
                        isClearable={true}
                        isLoading={isLoading}
                    />
                )}
                name={'trackedActivity'}
                control={control}
            />
        </div>
    ) : null;
};
